export default "__VITE_PUBLIC_ASSET__398775d5__"